import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tk",
  "use": "tk-usage",
  "viewBox": "0 0 203 108",
  "content": "<symbol viewBox=\"0 0 203 108\" xmlns=\"http://www.w3.org/2000/svg\" id=\"tk\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 0l43.25 24.686h70.78L57.87 108h21.962l81.326-35.456.422-.544h-38.53l29.545-48.343h36.244L203 0H0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol